import { render, staticRenderFns } from "./datasetsmodal.vue?vue&type=template&id=4e8fd020&scoped=true"
import script from "./datasetsmodal.vue?vue&type=script&lang=js"
export * from "./datasetsmodal.vue?vue&type=script&lang=js"
import style0 from "./datasetsmodal.vue?vue&type=style&index=0&id=4e8fd020&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8fd020",
  null
  
)

export default component.exports